export default __webpack_public_path__ + "static/media/feedback.8592b871.png";